import React, { useState } from 'react';
import { FaPlus, FaMinus } from 'react-icons/fa';
import PhoneCTA from './PhoneCTA';
import './FAQ.css';

const faqs = [
  {
    q: 'Are your OEM parts genuine or aftermarket?',
    a: 'We carry both genuine OEM parts sourced directly from manufacturers and high-quality aftermarket alternatives. All parts are clearly labeled, and our team can advise which option is best for your specific needs and budget.',
  },
  {
    q: 'How do I know the part will fit my vehicle?',
    a: 'Our VIN-verified fitment system ensures that every part is matched to your exact vehicle year, make, model, and trim level. If you provide your VIN number, our specialists will double-check fitment before shipping.',
  },
  {
    q: 'What is your return and warranty policy?',
    a: "We offer a 90-day warranty on all parts. If a part fails under normal use within 90 days, we'll send a replacement at no charge. Returns are accepted within 30 days for unused, uninstalled parts in original condition.",
  },
  {
    q: 'How fast will I receive my order?',
    a: 'Most in-stock orders placed before 2 PM EST ship the same day. Standard shipping takes 2–5 business days. Expedited 1–2 day shipping is also available. Free shipping on orders over $100.',
  },
  {
    q: "Can you source parts that aren't on your website?",
    a: "Yes! Our parts specialists can source virtually any automotive part through our nationwide network of 200+ verified suppliers. Contact us with your part request and we'll usually have a quote within 24 hours.",
  },
  {
    q: 'Do you offer bulk pricing for repair shops?',
    a: 'Absolutely. We have dedicated trade accounts for repair shops, dealerships, and fleet operators with volume discounts, net-30 payment terms, and a dedicated account manager. Contact us to set up your trade account.',
  },
];

const FAQ = () => {
  const [open, setOpen] = useState(null);

  return (
    <section className="faq" id="faq">
      <div className="faq-container">
        <div className="section-header">
          <div className="section-badge">GOT QUESTIONS?</div>
          <h2>Frequently Asked Questions</h2>
          <p>Everything you need to know about ordering parts with NX Auto Care by Nodex Global.</p>
        </div>

        <div className="faq-list">
          {faqs.map((f, i) => (
            <div
              className={`faq-item ${open === i ? 'open' : ''}`}
              key={i}
              onClick={() => setOpen(open === i ? null : i)}
            >
              <div className="faq-question">
                <span>{f.q}</span>
                <div className="faq-toggle">
                  {open === i ? <FaMinus /> : <FaPlus />}
                </div>
              </div>
              <div className="faq-answer">
                <p>{f.a}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="faq-footer">
          <p>Still have questions? Our parts experts are ready to help.</p>
          <PhoneCTA variant="primary" className="faq-cta" label="Call Our Parts Experts" />
        </div>
      </div>
    </section>
  );
};

export default FAQ;
